export enum AccessScopesEnum {
  // customer
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  CLIENT_EMPLOYEE = 'CLIENT_EMPLOYEE',
  // admin
  PORTAL_TEAM_LEAD = 'PORTAL_TEAM_LEAD',
  PORTAL_PROJECT_MANAGER = 'PORTAL_PROJECT_MANAGER',
  PORTAL_EMPLOYEE = 'PORTAL_EMPLOYEE'
}
